import React, { useState } from 'react'
import Select from 'react-select'
import { SwatchesPicker, SketchPicker, ChromePicker } from 'react-color'
import definePosition from './helpers/position'

export default function AlertTemplate({setOpen, data, setData}) {
  const [ alert, setAlert ] = useState({
    background: "#000",
    color: "#FFF",
    content: "Alerta de teste",
    position: "fr"
  })
  
  const [ cssPosition, setCssPosition ] = useState({
    string: "top: 15px; left: 15px;",
    react: {top: "45px", left: "15px"}
  })

  const handleColorChange = ({hex}, where) => setAlert({...alert, [where]: hex})

  const handleChange = (e, where) => {
    if ( where === "position" )
      setCssPosition(definePosition(e.value))

    setAlert({...alert, [where]: (e.target ? e.target.value : e.value)})
  }

  const hash = Math.random().toString(36).substring(7)
  const html = `
    <div class="celldcm__alert--${hash}">
      <a href="javascript:void(0);" onclick="this.parentNode.style.display = 'none'">X</a>
      <p>${alert.content}</p>
    </div>
  `

  const css = `
    .celldcm__alert--${hash} {
      background: ${alert.background};
      color: ${alert.color};
      position: fixed;
      max-width: 320px;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
      padding: 15px;
      padding-right: 45px;
      box-sizing: border-box;
      word-wrap: break-word;
      z-index: 9999;
      ${cssPosition.string}
    }

    .celldcm__alert--${hash} a,
    .celldcm__alert--${hash} p {
      color: inherit;
    }

    .celldcm__alert--${hash} p {
      word-wrap: break-word;
      font-size: 16px;
    }

    .celldcm__alert--${hash} a {
      position: absolute;
      text-decoration: none;
      top: 15px;
      right: 15px;
    }
  `

  const handleSave = () => {
    const arr = data.dispatcher ? data.dispatcher : [];
    
    setData({
      ...data,
      dispatcher: {
        ...arr,
        customHtml: html,
        customCss: css
      }
    });

    setOpen(false)
  }

  return (
    <>
      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>Conteúdo:</p>
        <textarea name="content" id="alert-content" className="basic-input basic-textarea" onChange={(e) => handleChange(e, "content")} defaultValue={alert.content}></textarea>
      </div>

      <div className="flex">
        <div className="titled__group" style={{width: "100%", marginTop: "30px", marginRight: "30px"}}>
          <p>Cor do fundo:</p>
          <SketchPicker color={alert.background} onChange={ (color) => handleColorChange(color, 'background') } />
        </div>
        <div className="titled__group" style={{width: "100%", marginTop: "30px"}}>
          <p>Cor do texto:</p>
          <SketchPicker color={alert.color} onChange={ (color) => handleColorChange(color, 'color') } />
        </div>
      </div>

      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>Posição:</p>
        <Select
          options={[
            {label: "Topo-esquerda", value: "te"},
            {label: "Topo-centro", value: "tc"},
            {label: "Topo-direita", value: "tr"},
            {label: "Centro-centro", value: "cc"},
            {label: "Centro-esquerda", value: "ce"},
            {label: "Centro-direita", value: "cr"},
            {label: "Fundo-centro", value: "fc"},
            {label: "Fundo-esquerda", value: "fe"},
            {label: "Fundo-direita", value: "fr"},
          ]}
          className="basic-select"
          classNamePrefix="select"
          placeholder="Selecione o template"
          onChange={(e) => handleChange(e, "position")}
          defaultValue={{label: "Topo-esquerda", value: "tc"}}
        />
      </div>

      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>Preview:</p>
        <div className="dcm__template-preview">
          {
            alert.content ?
              <div
                className="alert__template"
                style={{
                  ...cssPosition.react,
                  background: alert.background,
                  color: alert.color
                }}
              >
                <a href="javascript:void(0);" onclick="this.parentNode.style.display = 'none'">X</a>
                <p dangerouslySetInnerHTML={{__html: alert.content}}></p>
              </div>
            : null
          }
        </div>

        <button type="button" onClick={handleSave} className="btn btn-blue float-right" style={{marginTop: "30px"}}>Salvar</button>
      </div>
    </>
  )
}